import { Injectable } from '@angular/core';
import { GenericStateService } from '../../generic-state/generic-state.service';

@Injectable({
  providedIn: 'root'
})
export class TripStoreService extends GenericStateService<any> {

}
